/* BIG STUDIO - nav premium: glass + condense al scroll.
   Patron premium: el JS SOLO togglea una clase; el CSS hace la animacion (compositor). */
(function () {
  if (window.__bsNav) return;
  window.__bsNav = true;
  var root = document.documentElement;
  var ticking = false;
  var THRESH = 18;
  function apply() {
    root.classList.toggle('bs-scrolled', (window.scrollY || window.pageYOffset || 0) > THRESH);
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(apply); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();
